export const en = {
  dragDropYourPdfHere: 'Drag & drop your PDF here.',
  anErrorOccurredWhileLoadingTheDocument: 'An error occurred while loading the document.',
  noDocumentFound: 'No document found',
  page: 'Page',
  somethingWentWrongWhileLoadingTheDocument: 'Something went wrong while loading the document.',
  pleaseTryAgainOrContactOurSupport: 'Please try again or contact our support.',
  errorLoadingPage: 'Error loading page',
  lowRisk: 'Low Risk',
  mediumRisk: 'Medium Risk',
  highRisk: 'High Risk',
  search: 'Search',
  descending: 'Descending',
  ascending: 'Ascending',
  is: 'is',
  somethingWentWrong: 'Something went wrong.',
  noResultsFound: 'No results found',
  clearFilters: 'Clear filters',
  pagination: 'pagination',
  goToPreviousPage: 'Go to previous page',
  goToNextPage: 'Go to next page',
  morePages: 'More pages',
  previousSlide: 'Previous slide',
  nextSlide: 'Next slide',
  loading: 'Loading',
  sidebar: 'Sidebar',
  displaysTheMobileSidebar: 'Displays the mobile sidebar.',
  toggleSidebar: 'Toggle Sidebar',
  row: 'row',
  selected: 'selected.',
  rowsPerPage: 'Rows per page',
  goToFirstPage: 'Go to first page',
  goToLastPage: 'Go to last page',
  breadcrumb: 'breadcrumb',
  more: 'More',
  english: 'English',
  maskPassword: 'Mask password',
  revealPassword: 'Reveal password',
} as const;
export const fa: Record<keyof typeof en, string> = {
  dragDropYourPdfHere: 'فایل PDF را اینجا بکشید و رها کنید.',
  anErrorOccurredWhileLoadingTheDocument: 'مدرک بارگیری نشد.',
  noDocumentFound: 'مدرکی پیدا نشد',
  page: 'صفحه',
  somethingWentWrongWhileLoadingTheDocument: 'هنگام بارگیری مدرک مشکلی پیش آمد.',
  pleaseTryAgainOrContactOurSupport: 'دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.',
  errorLoadingPage: 'صفحه بارگیری نشد',
  lowRisk: 'ریسک پایین',
  mediumRisk: 'ریسک متوسط',
  highRisk: 'ریسک بالا',
  search: 'جست‌وجو',
  descending: 'نزولی',
  ascending: 'صعودی',
  is: 'برابر با',
  somethingWentWrong: 'مشکلی پیش آمد.',
  noResultsFound: 'نتیجه‌ای پیدا نشد',
  clearFilters: 'پاک کردن فیلترها',
  pagination: 'صفحه‌بندی',
  goToPreviousPage: 'صفحه قبل',
  goToNextPage: 'صفحه بعد',
  morePages: 'صفحه‌های بیشتر',
  previousSlide: 'اسلاید قبل',
  nextSlide: 'اسلاید بعد',
  loading: 'در حال بارگیری',
  sidebar: 'منوی کناری',
  displaysTheMobileSidebar: 'منوی کناری در موبایل',
  toggleSidebar: 'باز و بسته کردن منو',
  row: 'ردیف',
  selected: 'انتخاب شده است.',
  rowsPerPage: 'تعداد ردیف در صفحه',
  goToFirstPage: 'صفحه اول',
  goToLastPage: 'صفحه آخر',
  breadcrumb: 'مسیر صفحه',
  more: 'بیشتر',
  english: 'English',
  maskPassword: 'پنهان کردن رمز عبور',
  revealPassword: 'نمایش رمز عبور',
};
